export const ADDRESS_ID_FOR_DELIVERY = 'addressIdDel';
